<template>
  <v-row class="rowCount" no-gutters>
    <label class="grey--text">Show:</label>
    <v-btn-toggle
      v-model="selectedVal"
      tile
      color="#58e2c2"
      mandatory
      :data-test-id="`${dataTestId}__page-size-options`"
    >
      <v-btn
        x-small
        tile
        v-for="(item, index) in dataList"
        :key="index"
        :value="item.val"
        class="py-0 ma-0"
        @click="updateSelectedVal(item.val)"
        >{{ item.label }}</v-btn
      >
    </v-btn-toggle>
  </v-row>
</template>

<script>
import { getPageSizeList } from '../../helpers/TableHelpers';
export default {
  data() {
    return {
      selectedVal: 5,
      dataList: [],
      countList: this.customDataList
        ? this.customDataList
        : this.copyArray(getPageSizeList(this.pageSizeOption))
    };
  },
  watch: {
    // eslint-disable-next-line
    defaultSelected(newValue, oldValue) {
      this.selectedVal = newValue;
    }
  },
  props: {
    customDataList: Array,
    pageSizeOption: String,
    list: Array,
    defaultSelected: {
      type: Number,
      default: 20
    },
    dataTestId: String
  },
  mounted() {
    if (Array.isArray(this.list) && this.list.length) {
      this.dataList = this.list;
    } else {
      this.dataList = this.countList;
    }
    this.selectedVal = this.defaultSelected;
  },
  methods: {
    updateSelectedVal(selectedVal) {
      if (this.selectedVal !== selectedVal) {
        this.$emit('recordsSelected', selectedVal);
      }
    }
  }
};
</script>

<style scoped>
.v-btn-toggle .v-btn {
  border: 0 !important;
  background: #fff !important;
}
</style>
